import { useLingui } from '@lingui/react'
import type { FC } from 'react'

import { PAGE_TYPE_SEARCH_RESULTS } from 'shared/consts'
import { subscribe } from 'shared/store'
import { MODAL_SHOWN } from 'shared/store/ducks/events'
import type { PageType } from 'types/cmsTypes'
import shopLogo from 'views/assets/images/logos/logo-de-desktop.svg'
import zavaLogo from 'views/assets/images/logos/logo-zava.svg'
import { REDIRECT_DELAY_MS } from 'views/assets/scripts/consts'
import AnimatedDots from 'views/components/atoms/AnimatedDots'
import Image from 'views/components/atoms/Image'
import Modal from 'views/components/molecules/Modal'
import TransWithHtml from 'views/components/utils/TransWithHtml'
import { ODS_MODAL_SEARCH_PAGE_BTN_ID } from 'views/consts'

import { ODS_TRANSITION_MODAL_ID } from './names'

type Props = {
  pageType: PageType
}

const onShowModal = (pageType: PageType) => {
  if (pageType !== PAGE_TYPE_SEARCH_RESULTS) return
  setTimeout(() => {
    /**
     * url is set on this button from [odsIndikationUrl.js](app/views/assets/scripts/odsIndikationUrl.js)
     */
    const url = document
      .getElementById(ODS_MODAL_SEARCH_PAGE_BTN_ID)
      ?.getAttribute('href') as string
    window.location.href = `https://${url}`
  }, REDIRECT_DELAY_MS)
}

const OdsTransitionModal: FC<Props> = ({ pageType }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  subscribe.after(MODAL_SHOWN, ({ modalName }: any) => {
    if (modalName === ODS_TRANSITION_MODAL_ID) {
      onShowModal(pageType)
    }
  })

  const { i18n } = useLingui()

  return (
    <Modal
      {...{
        id: ODS_TRANSITION_MODAL_ID,
        open: false,
        size: 'small',
        isClientSideControlled: false,
        role: 'alertdialog',
        hideCloseButton: true,
      }}
    >
      <div
        className="l-flex l-flex--center l-flex__column u-padding-x-large"
        data-qa-id="ods-transition-modal-content-container"
      >
        <div className="l-flex u-margin-large--bottom">
          <Image
            className="max100width-image u-margin--right"
            src={shopLogo}
            alt={'Shop Apotheke'}
            height={60}
            width={150}
          />
          <Image
            className="max100width-image u-margin--left"
            src={zavaLogo}
            height={60}
            width={150}
            alt="Zava"
          />
        </div>
        <div className="u-margin--bottom">
          <h2 className="a-h2 u-text-align--center">
            <TransWithHtml text={i18n._('ods.transition.partner.zava')} />
          </h2>
        </div>
        <div>
          <AnimatedDots />
        </div>
      </div>
    </Modal>
  )
}

export default OdsTransitionModal
